import Vue from 'vue'

Vue.mixin({
    methods: {
        capitalizeFirstLetter (str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        }
    }
})
